<template>
  <div>
    <!-- 筛选项 -->
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit" width="100px" :key="formNum" ref="searchForm">
      <div class="component_title2">
        <el-popover placement="rigth" trigger="click">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px">
            <el-row>
              <el-col :md="12" :lg="8" :sm="24">
                <el-form-item label="交易号" prop="transcation_no">
                  <el-input v-model.trim="searchForm.transcation_no" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12" :lg="8" :sm="24">
                <el-form-item label="支付平台APPID" prop="pay_appid" label-width="140px">
                  <el-input v-model.trim="searchForm.pay_appid" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12" :lg="8" :sm="24">
                <el-form-item label="App版本号" prop="app_version">
                  <SelectCustomize :value="app_versionInfo" @changeScope="changeapp_version" :data="app_versionIds" />
                </el-form-item>
              </el-col>
              <el-col :md="12" :lg="8" :sm="24">
                <el-form-item label="支付方式" prop="pay_way">
                  <SelectCustomize :value="pay_wayInfo" @changeScope="changepay_way" :data="pay_wayIds" />
                </el-form-item>
              </el-col>
              <el-col :md="12" :lg="8" :sm="24">
                <el-form-item label="订单号" prop="ostr">
                  <el-input v-model.trim="searchForm.ostr" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12" :lg="8" :sm="24">
                <el-form-item label="用户ID" prop="uid">
                  <el-input v-model.trim="searchForm.uid" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>

              <el-col :md="12" :lg="8" :sm="24">
                <el-form-item label="购买路径" prop="form_path">
                  <el-cascader v-model="form_pathInfo" @change="changeform_path" :options="form_pathIds" :props="{
                    multiple: true,
                    value: 'id',
                    label: 'title',
                  }" filterable collapse-tags></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :md="12" :lg="8" :sm="24">
                <el-form-item label="订阅协议号" prop="agreement_no">
                  <el-input v-model.trim="searchForm.agreement_no" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-button slot="reference" type="text">更多选项<span class="el-icon-arrow-down"></span></el-button>
        </el-popover>
      </div>
      <el-col :md="12" :lg="8" :sm="24">
        <el-form-item label="创建日期" prop="create_time">
          <dataPicker :clearFlag="searchForm.pay_time.length || searchForm.activate_time.length
            " :datevalue.sync="searchForm.create_time" @change="create_timeChange"></dataPicker>
        </el-form-item>
      </el-col>
      <el-col :md="12" :lg="8" :sm="24">
        <el-form-item label="支付日期" prop="pay_time">
          <dataPicker :clearFlag="searchForm.create_time.length || searchForm.activate_time.length
            " :datevalue.sync="searchForm.pay_time" @change="create_timeChange"></dataPicker>
        </el-form-item>
      </el-col>
      <el-col :md="12" :lg="8" :sm="24">
        <el-form-item label="激活日期" prop="activate_time">
          <dataPicker :clearFlag="searchForm.create_time.length || searchForm.pay_time.length
            " :datevalue.sync="searchForm.activate_time" @change="create_timeChange"></dataPicker>
        </el-form-item>
      </el-col>
      <el-col :md="12" :lg="8" :sm="24">
        <el-form-item label="是否首单" prop="is_first">
          <SelectCustomize :value="is_firstInfo" @changeScope="changeis_first" :data="is_firstIds" />
        </el-form-item>
      </el-col>
      <el-col :md="12" :lg="8" :sm="24">
        <el-form-item label="归因渠道" prop="origin">
          <!-- <SelectCustomize
            :value="originInfo"
            @changeScope="changeorigin"
            :data="originIds"
          /> -->
          <SelectChannel v-model="searchForm.origin" multi></SelectChannel>
        </el-form-item>
      </el-col>
      <el-col :md="12" :lg="8" :sm="24">
        <el-form-item label="支付渠道" prop="channel">
          <!-- <SelectCustomize
            :value="channelInfo"
            @changeScope="changechannel"
            :data="channelIds"
          /> -->
          <SelectChannel v-model="searchForm.channel" multi></SelectChannel>
        </el-form-item>
      </el-col>
      <el-col :md="12" :lg="8" :sm="24">
        <el-form-item label="支付状态" prop="is_pay">
          <SelectCustomize :value="is_payInfo" @changeScope="changeis_pay" :data="is_payIds" />
        </el-form-item>
      </el-col>
      <el-col :md="12" :lg="8" :sm="24">
        <el-form-item label="商品类型" prop="goods_title">
          <SelectCustomize :value="goods_titleInfo" @changeScope="changegoods_title" :data="goods_titleIds" />
        </el-form-item>
      </el-col>
      <el-col :md="12" :lg="8" :sm="24">
        <el-form-item label="订单类型" prop="order_cate">
          <el-select v-if="showCascader" v-model="searchForm.order_cate" placeholder="请选择"
            :popper-append-to-body="false" :clearable="true">
            <el-option v-for="(v, i) in order_cateIds" :key="i" :label="v.title" :value="v.id" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="12" :lg="8" :sm="24">
        <el-form-item label="国家筛选" prop="country_iso">
          <SelectCustomize :value="country_isoInfo"  :data="countryOptions" @changeScope="changeCountryIso"></SelectCustomize>
        </el-form-item>

      </el-col>
      <el-col :md="12" :lg="8" :sm="24">
        <el-form-item label=" " prop="is_day">
          <el-checkbox v-model="is_day">激活付费精确到天</el-checkbox>
        </el-form-item>
      </el-col>
      <el-button @click="initFrom" slot="btn-option">重置筛选</el-button>
    </FilterLayout>
    <!-- 指示看板 -->
    <div class="dash_board">
      <div class="dash_board_card">
        <el-col :lg="4" :sm="12" v-for="(v, i) in frontDashBoardData" :key="i">
          <div class="box">
            <div class="title">{{ v.title }}</div>
            <div class="money">
             {{ v.unit }}  {{ parseFloat(v.value).toLocaleString() }}
            </div>
          </div>
        </el-col>
      </div>
    </div>
    <TableLayout :column="column" :data="tableData.data" :total="tableData.total" :loading="tableData.loading"
      :currentPage="tableOpt.currentPage" :params="searchForm" @sizeChange="onSizeChange" @pageChange="onPageChange"
      alignStyle="center" leadApi="App/orderList" :leadOut="true" tableSize="mini" @sortChange="onSortChange"
      :channelFlag="true">
    </TableLayout>
  </div>
</template>

<script>
import moment from "moment";
import store from "store2";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import SelectChannel from "@/component/select-channel";
import SelectCustomize from "@/component/select-customize";
export default {
  components: {
    FilterLayout,
    SelectCustomize,
    TableLayout,
    SelectChannel,
  },
  data() {
    return {
      countryOptions: [], // 国家筛选列表数据
      showCascader: 1,
      is_day: false,
      pay_timeFlag: true,
      create_timeFlag: true,
      activate_timeFlag: true,
      form_pathFlag: true,
      form_pathInfo: [],
      searchForm: {
        //筛选项
        origin: [],
        is_pay: "",
        channel: [],
        uid: "",
        ostr: "",
        country_iso:[],
        transcation_no: "",
        agreement_no: "",
        pay_appid: "",
        app_version: [],
        pay_way: [],
        goods_title: [],
        order_cate: "",
        is_first: [],
        form_path: [],
        is_day: 1,
        pay_time: [],
        activate_time: [],
        create_time: [
          moment().subtract(7, "d").format("YYYY-MM-DD"),
          moment().subtract(0, "d").format("YYYY-MM-DD"),
        ],
      },
      column: [
        {
          label: "app",
          prop: "app_title",
          width: "120",
        },
        {
          label: "app版本",
          prop: "app_version",
        },
        {
          prop: "system_title",
          label: "系统",
        },
        {
          prop: "uid",
          label: "用户ID",
        },
        {
          prop: "country_iso",
          label: "用户国家",
        },
        {
          prop: "uuid",
          label: "设备唯一标识",
          width: 200,
        },
        {
          prop: "origin",
          label: "归因渠道",
          width: 80,
        },
        {
          prop: "channel",
          label: "支付渠道",
          width: 150,
        },
        {
          prop: "aid",
          label: "广告计划AID",
          width: 150,
        },
        {
          prop: "cid",
          label: "广告CID",
          width: 150,
        },
        {
          prop: "is_pay",
          label: "支付情况",
        },
        {
          prop: "pay_way",
          label: "支付方式",
          width: 120,
        },
        {
          prop: "goods_title",
          label: "商品名称",
          width: 120,
        },
        {
          prop: "order_cate",
          label: "订单类型",
        },
        {
          prop: "from_path",
          label: "购买路径",
          width: 180,
        },
        {
          prop: "is_first",
          label: "是否首单",
          with: 80
        },
        {
          prop: "ostr",
          label: "订单号",
          width: 180,
        },
        {
          prop: "transcation_no",
          label: "交易号",
          width: 180,
        },
        {
          prop: "agreement_no",
          label: "订阅协议号",
          width: 180,
        },
        {
          prop: "pay_appid",
          label: "支付平台APPID",
          width: 180,
        },
        {
          prop: "create_date",
          label: "订单创建时间",
          sortable: "custom",
          width: 160,
        },
        {
          prop: "pay_time",
          label: "支付时间",
          sortable: "custom",
          width: 160,
        },
        {
          label: "激活日期",
          prop: "activate_time",
          sortable: "custom",
          width: 160,
        },
        {
          prop: "pay_fee",
          label: "支付金额（元）",
          sortable: "custom",
        },
        {
          prop: "us_amount",
          label: "订单金额（美元）",
          sortable: "custom",
        },
        {
          prop: "us_receive_amount",
          label: "应收金额（美元）",
          sortable: "custom",
        },
      ],
      tableData: {
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        loading: false,
      },
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      apps: [],
      systemIds: [
        {
          id: "1",
          title: "Android",
        },
        {
          id: "2",
          title: "ios",
        },
        {
          id: "3",
          title: "小程序",
        },
      ],//设备
      originIds: [],
      is_payIds: [
        {
          id: "1",
          title: "已支付",
        },
        {
          id: "0",
          title: "未支付",
        },
      ], //支付状态
      channelIds: [],
      app_versionIds: [],
      pay_wayIds: [
        {
          id: "3",
          title: "Apple Pay",
        },
        {
          id: "2",
          title: "支付宝",
        },
        {
          id: "1",
          title: "微信",
        },
        {
          id: "4",
          title: "QQ支付",
        },
        {
          id: "5",
          title: "卡密支付",
        },
      ],//支付方式
      order_cateIds: [
        {
          id: "",
          title: "全选",
        },
        {
          id: "1",
          title: "普通订单",
        },
        {
          id: "2",
          title: "订阅订单",
        },
        {
          id: "3",
          title: "其他",
        },
      ],//订单类型
      is_firstIds: [
        {
          id: "1",
          title: "是",
        },
        {
          id: "0",
          title: "否",
        },
      ],//是否首单
      form_pathIds: [],
      goods_titleIds: [],
      systemInfo: {
        appInfo: [],
      },
      originInfo: {
        appInfo: [],
      },
      is_payInfo: {
        appInfo: [],
      },
      channelInfo: {
        appInfo: [],
      },
      app_versionInfo: {
        appInfo: [],
      },
      pay_wayInfo: {
        appInfo: [],
      },
      order_cateInfo: {
        appInfo: [],
      },
      is_firstInfo: {
        appInfo: [],
      },
      goods_titleInfo: {
        appInfo: [],
      },
      country_isoInfo:{
        appInfo: [],
      },
      // 指示看板数据
      frontDashBoardData: [
        {
          unit:"￥",
          prop: "order_cost",
          value: "0",
          title: "订单金额",
        },
        {
          unit:"$",
          prop: "us_amount",
          value: "0",
          title: "订单金额（美元）",
        },
        {
          unit:"$",
          prop: "us_receive_amount",
          value: "0",
          title: "应收金额（美元）",
        },
        {
          unit:"",
          prop: "order_num",
          value: "0",
          title: "订单量",
        },
        {
          unit:"",
          prop: "user_num",
          value: "0",
          title: "下单人数",
        },
        {
          unit:"",
          prop: "unit_price",
          value: "0",
          title: "客单价",
        },
      ],
      sort: {
        prop: "",
        order: "",
      },
      formNum: 1,
    };
  },
  mounted() {
    this.getReport();
    this.getRoleBtree();
    this.getVersion();
    this.getOrderKanban();
    this.getOrderScreening();
    this.getCountryData() // 获取国家代码
  },
  methods: {
    async getCountryData() {
      const [err, res] = await this.$http.post("App/get_country");
      if (err) return
      this.countryOptions = res.map(el=>{
        return {
          title:el.country,
          id:el.country_iso
        }
      })
    },
    onSortChange(data) {
      const { prop, order } = data;
      this.sort = { prop, order };
      this.tableOpt.currentPage = 1;
      this.getReport();
    },
    // 获取表单的数据tabledata对应项的数据
    async getReport() {
      this.tableData.loading = true;
      this.is_day
        ? (this.searchForm.is_day = "1")
        : (this.searchForm.is_day = "0");
      const { searchForm, tableOpt, sort } = this;
      const [err, res] = await this.$http.post("App/orderList", {
        appId: this.$route.query.appId,
        ...tableOpt,
        ...searchForm,
        ...sort,
      });
      this.tableData.loading = false;
      if (err) {
        this.tableData = {
          data: [],
          total: 0,
          currentPage: 1,
          pageSize: 10,
          loading: false,
        };
        return;
      }
      const { list, currentPage, total } = res;
      for (const i of list) {
        i.app_title = i.app_title ? i.app_title.split("_")[0] : "";
      }
      //赋值表单数据
      this.tableData.data = list;
      //赋值表单当前页
      this.tableData.currentPage = currentPage;
      //赋值表单数据总条数
      this.tableData.total = total;
    },
    create_timeChange(val) {
      this.getOrderScreening();
      this.getVersion();
    },
    changeorigin(val) {
      this.searchForm.origin = val.appInfo;
    },
    changechannel(val) {
      this.searchForm.channel = val.appInfo;
    },
    changeis_pay(val) {
      //改变支付状态之后的赋值操作
      this.searchForm.is_pay = val.appInfo;
    },
    changeapp_version(val) {
      this.searchForm.app_version = val.appInfo;
    },
    changepay_way(val) {
      this.searchForm.pay_way = val.appInfo;
    },
    changeform_path(val) {
      if (val.length == 0) {
        this.searchForm.from_path_one = [];
        this.searchForm.from_path_two = [];
        this.searchForm.from_path_three = [];
      } else {
        let arr = [[], [], []];
        val.forEach((item) => {
          item.forEach((_item, index) => {
            arr[index].push(_item);
          });
        });
        this.searchForm.from_path_one = arr[0];
        this.searchForm.from_path_two = arr[1];
        this.searchForm.from_path_three = arr[2];
      }
    },
    changeis_first(val) {
      this.searchForm.is_first = val.appInfo;
    },
    changegoods_title(val) {
      this.searchForm.goods_title = val.appInfo;
    },
    // 改变国家
    changeCountryIso(val){
      this.searchForm.country_iso = val.appInfo;
    },
    onPageChange(current) {
      this.tableOpt.currentPage = current;
      this.getReport();
    },
    onSizeChange(current) {
      this.tableOpt.pageSize = current;
      this.getReport();
    },
    async getRoleBtree() {
      const [err, res] = await this.$http.post("System/roleBtree", {
        loginId: store.get("user")["id"],
        loginToken: store.get("loginToken"),
        appId: this.$route.query.appId,
      });
      if (err) return;
      this.department_id = res.tree;
      res.list.forEach((item) => {
        if (item.title == "应用") {
          item.node.forEach((_item) => {
            if (_item.system == "1") {
              _item.title = _item.title + "_Android";
            } else if (_item.system == "2") {
              _item.title = _item.title + "_IOS";
            } else if (_item.system == "3") {
              _item.title = _item.title + "_微信小程序";
            }
          });
        }
      });
      this.departDatas = [
        ...res.list,
        { id: 1005, title: "系统", node: [...this.systemIds] },
      ];
      let group_id = [];
      res.tree.forEach((item) => {
        item.node.forEach((_item) => {
          group_id.push(_item);
        });
      });
      this.group_id = group_id;
      let apps = [];
      let article_id_arr = [];
      res.tree.forEach((item) => {
        item.node.forEach((_item) => {
          article_id_arr.push(..._item.node);
          _item.node.forEach((__item) => {
            apps.push(...__item.node);
          });
        });
      });
      this.article_id = article_id_arr;
    },
    onSubmit() {
      this.tableOpt.currentPage = 1
      this.getReport();
      this.getOrderKanban();
    },
    async getVersion() {
      const { searchForm } = this;
      const [err, res] = await this.$http.post("App/versionChannel", {
        ...searchForm,
        appId: this.$route.query.appId,
      });
      if (err) {
        return;
      }
      this.app_versionIds = [];
      this.app_versionInfo = {
        appInfo: [],
      };
      this.searchForm.app_version = [];
      this.app_versionIds = res.list[0].children;
    },
    async getOrderKanban() {
      const { searchForm } = this;
      const [err, res] = await this.$http.post("App/orderKanban", {
        ...searchForm,
        appId: this.$route.query.appId,
      });
      if (err) {
        return;
      }
      // 动态渲染看板
      for (const el of this.frontDashBoardData) {
        if (el.prop in res) {
          el.value = res[el.prop]
        }
      }
    },

    async getOrderScreening() {
      this.goods_titleIds = [];
      this.goods_titleInfo.appInfo = [];
      this.searchForm.goods_title = [];
      this.form_pathInfo = [];
      const { searchForm } = this;
      const [err, res] = await this.$http.post("App/orderScreening", {
        appId: this.$route.query.appId,
        ...searchForm,
      });
      if (err) {
        return;
      }
      //商品类型
      this.goods_titleIds = res.list[0].children;
      //订单路径
      this.form_pathIds = res.list[1].children;
      this.showCascader += 1;
    },
    initFrom() {
      this.originInfo.appInfo = [];
      this.is_payInfo.appInfo = [];
      this.channelInfo.appInfo = [];
      this.app_versionInfo.appInfo = [];
      this.pay_wayInfo.appInfo = [];
      this.order_cateInfo.appInfo = [];
      this.goods_titleInfo.appInfo = [];
      this.country_isoInfo.appInfo = [];
      this.is_firstInfo.appInfo = [];
      this.searchForm.channel = [];
      this.searchForm.origin = [];
      this.searchForm.is_pay = [];
      this.searchForm.uid = "";
      this.searchForm.ostr = "";
      this.searchForm.transcation_no = "";
      this.searchForm.agreement_no = "";
      this.searchForm.pay_appid = "";
      this.searchForm.app_version = [];
      this.searchForm.pay_way = [];
      this.searchForm.goods_title = [];
      this.searchForm.order_cate = "";
      this.searchForm.is_day = 1;
      this.searchForm.is_first = [];
      this.searchForm.form_path = [];
      this.searchForm.pay_time = [];
      this.searchForm.activate_time = [];
      this.searchForm.country_iso = [];
      this.form_pathInfo = [];
      this.searchForm.create_time = [
        moment().subtract(7, "d").format("YYYY-MM-DD"),
        moment().subtract(0, "d").format("YYYY-MM-DD"),
      ];
      this.formNum += 1;
    },
  },
};
</script>

<style lang="less" scoped>
.component_title2 {
  background: #fff;
  padding: 1px 0 5px 15px;
}

.component_title {
  background: #fff;
  padding: 20px 0 10px 15px;
  font-weight: bold;
}

.dash_board {
  margin: 20px 0;
  background: #fff;
  min-height: 118px;

  .box {
    border-radius: 4px;
    border: 1px solid #ebebeb;
    text-align: center;
    padding: 20px 0;
    margin: 15px 7px;
    box-sizing: border-box;

    &:hover {
      background: #fff7ed;
      border: 1px solid #ffc580;
    }

    .title {
      font-size: 12px;
    }

    .money {
      font-size: 18px;
      font-weight: bold;
    }

    .up {
      color: #ea5454;
    }

    .down {
      color: #17bf5e;
    }

    .per {
      display: flex;
      justify-content: space-around;
      height: 40px;
      margin-top: 8px;

      div {
        vertical-align: middle;
        font-size: 12px;
        height: 25px;
      }
    }
  }
}

.dash_board_card {
  display: flex;
  justify-content: center;
  height: 100px;
}

.dark_item {
  position: absolute;
  top: 10px;
  right: -10px;
}
</style>
